import React, { useState } from "react";

import EyeIcon from "../../../assets/icons/EyeIcon";
import EditIcon from "../../../assets/icons/EditIcon";

import NoDataIcon from "../../../assets/icons/NoDataIcon";
import ProductLinkIcon from "../../../assets/product-link.svg";
import { useSelector } from "react-redux";
// import { hasFeatureAccess, FEATURES } from "../../../config/roleFeatures";
// import { useAppSelector } from "../../../store/hooks";
import ProductLinkModal from "./ProductLinkModal";
import "../../../style/product.css";

const ProductTable = ({ products, onView, onEdit, onDelete }) => {
  const { isPartsURL, isAccessoriesURL, isGodownURL } = useSelector((state) => state.domain);
  const isLoycomDomain =
    window.location.hostname === process.env.REACT_APP_WEB_LOYCOM_URL;
  const [linkProduct, setLinkProduct] = useState(null);
  
  // Mock data for frontend development when backend is down
  const mockProducts = [
    {
      id: "mock-1",
      name: "iPhone 15 Pro Max",
      ram: "8GB",
      storage: "256GB",
      variants: [{ color: "Natural Titanium" }],
      suffix: "EU Spec",
      used_mobile: false,
      category_name: "Smartphones",
      unique_identifier_identifier: "IP15PM-256-NT",
      avg_buying_price: 1050.00,
      avg_selling_price: 1199.99,
      in_stock: 15,
      location: "Shelf A1",
      status: "in stock"
    },
    {
      id: "mock-2",
      name: "Samsung Galaxy S24 Ultra",
      ram: "12GB",
      storage: "512GB",
      variants: [{ color: "Titanium Black" }],
      suffix: "Global",
      used_mobile: false,
      category_name: "Smartphones",
      unique_identifier_identifier: "S24U-512-TB",
      avg_buying_price: 980.00,
      avg_selling_price: 1249.00,
      in_stock: 8,
      location: "Shelf B2",
      status: "low"
    }
  ];

  // Use mock data if products is null, undefined, or an empty array
  const displayProducts = (products && products.length > 0) ? products : mockProducts;
  // const { user } = useAppSelector((state) => state.auth);
  // const userRole = user?.admin_role?.toUpperCase();

  // Check if user can edit products
  // const canWriteProducts = hasFeatureAccess(userRole, FEATURES.PRODUCTS_WRITE);

  const getStatusColor = (status) => {
    switch (status) {
      case "out of stock":
        return "#FF5356";
      case "low":
        return "#FE9400";
      case "in stock":
        return "#0CAE00";
      default:
        return "#FF5356";
    }
  };

  return (
    <>
      <div className="product-table-container">
        {/* Fixed Header */}
        <div className="product-table-header-container">
          <table className={`product-table ${isGodownURL ? 'product-table-godown' : ''}`}>
            <thead style={{ borderRadius: "8px" }}>
              <tr>
                <th style={{ borderTopLeftRadius: "8px" }}>NAME</th>
                <th>CATEGORY</th>
                {(isAccessoriesURL || isGodownURL) && <th>TAG</th>}
                <th>AVG. BUYING PRICE</th>
                <th>AVG. SELLING PRICE</th>
                <th>IN STOCK</th>
                {isGodownURL && <th>LOCATION</th>}
                <th>STATUS</th>
                <th style={{ textAlign: "center", borderTopRightRadius: "8px" }}>
                  ACTION
                </th>
              </tr>
            </thead>
          </table>
        </div>

        {/* Scrollable Body */}
        <div className="product-table-body-container">
          <table className={`product-table ${isGodownURL ? 'product-table-godown' : ''}`}>
            <tbody>
              {displayProducts.length === 0 && (
                <tr>
                  <td colSpan={isGodownURL || isAccessoriesURL ? "9" : "7"} className="no-products-message">
                    <div
                      className=""
                      style={{
                        marginBottom: "4rem",
                        marginTop: "4rem",
                      }}
                    >
                      <NoDataIcon />
                      <h3 style={{ marginTop: "2rem" }}>No Products Found</h3>
                    </div>
                  </td>
                </tr>
              )}
              {displayProducts.map((product) => (
                <tr key={product.id}>
                  <td className="product-name">
                    <div>
                      <div className="product-name-text" title={product.name}>{product.name}</div>
                      <div
                        className="product-name-details"
                        title={[
                          product.ram,
                          product.storage,
                          product.variants?.map(v => Object.values(v).join(", ")).join(", "),
                          product.suffix,
                          product.used_mobile !== undefined && product.used_mobile !== null ? (product.used_mobile === false ? "New" : "Used") : null
                        ].filter(Boolean).join(" | ")}
                        style={{
                          fontSize: "0.8em",
                          color: "#666",
                          marginTop: "4px",
                        }}
                      >
                        {product.ram && `${product.ram}`}
                        {product.ram && product.storage && " | "}
                        {product.storage && `${product.storage}`}
                        {product.variants && product.variants.length > 0 && (
                          <>
                            {(product.ram || product.storage) && " | "}
                            {product.variants
                              .map((variant) => Object.values(variant).join(", "))
                              .join(", ")}
                          </>
                        )}
                        {product.suffix && (
                          <>
                            {(product.ram ||
                              product.storage ||
                              (product.variants &&
                                product.variants.length > 0)) &&
                              " | "}
                            {product.suffix}
                          </>
                        )}
                        {product.used_mobile !== undefined &&
                          product.used_mobile !== null && (
                            <>
                              {(product.ram ||
                                product.storage ||
                                (product.variants &&
                                  product.variants.length > 0) ||
                                product.suffix) &&
                                " | "}
                              {product.used_mobile === false ? "New" : "Used"}
                            </>
                          )}
                      </div>
                    </div>
                  </td>

                  <td>{product.category_name || "N/A"}</td>
                  {isAccessoriesURL && <td>{product.unique_identifier_identifier || "-"}</td>}
                  {isGodownURL && <td>{product.unique_identifier_identifier || "-"}</td>}
                  <td>€{parseFloat(product.avg_buying_price || 0).toFixed(2)}</td>
                  <td>
                    €{parseFloat(product.avg_selling_price || 0).toFixed(2)}
                  </td>
                  <td>{product.in_stock || 0}</td>
                  {isGodownURL && <td>{product.location || "-"}</td>}
                  <td className="status-cell">
                    <span
                      className="status-dot"
                      style={{
                        backgroundColor: getStatusColor(product.status),
                      }}
                    ></span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      {!isLoycomDomain && (
                        <button
                          className={`${isPartsURL ? "action-btn-parts view" : isAccessoriesURL ? "action-btn-acc view" : isGodownURL ? "action-btn-godown view" : "action-btn view"}`}
                          onClick={() => setLinkProduct(product)}
                          title="Link"
                        >
                          <img src={ProductLinkIcon} alt="link" style={{ width: 16, height: 16 }} />
                        </button>
                      )}
                      <button
                        className={`${isPartsURL ? "action-btn-parts view" : isAccessoriesURL ? "action-btn-acc view" : isGodownURL ? "action-btn-godown view" : "action-btn view"}`}
                        onClick={() => onView(product)}
                        title="View"
                      >
                        <EyeIcon fill={isPartsURL ? "var(--primary-color-parts)" : isAccessoriesURL ? "var(--primary-color-acc)" : isGodownURL ? "var(--primary-color-godown)" : "#2F80ED"} />
                      </button>
                      {isAccessoriesURL ? ("") : (
                        <button
                          className={`${isPartsURL ? "action-btn-parts view" : isAccessoriesURL ? "action-btn-acc view" : isGodownURL ? "action-btn-godown view" : "action-btn view"}`}
                          onClick={() => onEdit(product)}
                          title="Edit"
                        >
                          <EditIcon fill={isPartsURL ? "var(--primary-color-parts)" : isAccessoriesURL ? "var(--primary-color-acc)" : isGodownURL ? "var(--primary-color-godown)" : "#2F80ED"} />
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Product Link Modal */}
      {linkProduct && (
        <ProductLinkModal
          isOpen={true}
          onClose={() => setLinkProduct(null)}
          product={linkProduct}
        />
      )}
    </>
  );
};

export default ProductTable;
